module.exports = __webpack_public_path__ + "img/video2x.c4ea89bb.png";